/**
 * Holster: hide PayPal express when cart or PDP contains tobacco
 * (tag category:tobacco). Theme-layer enforcement. Other wallets (e.g. Google Pay) stay.
 */
(function () {
  'use strict';

  var NOTE =
    'PayPal ist bei Tabak nicht verfügbar.';
  var RESTRICTED_TYPES = ['tobacco'];
  var RESTRICTED_TAG_FRAGMENTS = ['category:tobacco', 'cat:tobacco'];

  function cfg() {
    var el = document.getElementById('holster-paypal-config');
    if (!el) return { restricted: false, note: NOTE };
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return { restricted: false, note: NOTE };
    }
  }

  function typeRestricted(type) {
    var t = String(type || '').toLowerCase().trim();
    if (!t) return false;
    for (var i = 0; i < RESTRICTED_TYPES.length; i++) {
      if (t === RESTRICTED_TYPES[i] || t.indexOf(RESTRICTED_TYPES[i]) !== -1) {
        return true;
      }
    }
    return t.indexOf('tabak') !== -1;
  }

  function tagsRestricted(tags) {
    var list = Array.isArray(tags) ? tags : String(tags || '').split(',');
    var joined = list
      .map(function (x) {
        return String(x || '').toLowerCase();
      })
      .join(',');
    if (!joined) return false;
    for (var i = 0; i < RESTRICTED_TAG_FRAGMENTS.length; i++) {
      if (joined.indexOf(RESTRICTED_TAG_FRAGMENTS[i]) !== -1) return true;
    }
    return false;
  }

  function itemRestricted(item) {
    if (!item) return false;
    if (typeRestricted(item.product_type || item.productType)) return true;
    if (tagsRestricted(item.tags || item.product_tags)) return true;
    return false;
  }

  function setRestricted(on) {
    document.documentElement.classList.toggle('holster-paypal-restricted', !!on);
    document.documentElement.setAttribute(
      'data-holster-paypal-restricted',
      on ? 'true' : 'false'
    );
    syncNotes(!!on);
    hideButtons(!!on);
  }

  function isPayPalNode(node) {
    if (!node || node.nodeType !== 1) return false;
    var cls = typeof node.className === 'string' ? node.className : String(node.className || '');
    var hay = [
      cls,
      node.id || '',
      node.getAttribute('title') || '',
      node.getAttribute('name') || '',
      node.getAttribute('src') || '',
      node.getAttribute('aria-label') || '',
      node.getAttribute('data-testid') || '',
    ]
      .join(' ')
      .toLowerCase();
    return hay.indexOf('paypal') !== -1 || hay.indexOf('pay pal') !== -1;
  }

  function toggleHidden(node, on) {
    if (on) {
      node.setAttribute('data-holster-paypal-hidden', '1');
      node.style.setProperty('display', 'none', 'important');
      node.style.setProperty('visibility', 'hidden', 'important');
      node.style.setProperty('pointer-events', 'none', 'important');
    } else if (node.getAttribute('data-holster-paypal-hidden') === '1') {
      node.removeAttribute('data-holster-paypal-hidden');
      node.style.removeProperty('display');
      node.style.removeProperty('visibility');
      node.style.removeProperty('pointer-events');
    }
  }

  function hideInRoot(root, on) {
    if (!root || !root.querySelectorAll) return;
    var selectors = [
      '.shopify-payment-button__button--paypal',
      '#paypal-button-container',
      '.paypal-buttons',
      '[data-paypal-button]',
      '[data-holster-paypal-hidden="1"]',
    ];
    selectors.forEach(function (sel) {
      root.querySelectorAll(sel).forEach(function (node) {
        toggleHidden(node, on);
      });
    });
    root.querySelectorAll('*').forEach(function (node) {
      if (on && isPayPalNode(node)) toggleHidden(node, on);
      if (!on && node.getAttribute('data-holster-paypal-hidden') === '1') {
        toggleHidden(node, false);
      }
      if (node.shadowRoot) hideInRoot(node.shadowRoot, on);
    });
  }

  function hideButtons(on) {
    // Never hide the whole accelerated-checkout host (Google Pay must remain).
    var hosts = document.querySelectorAll(
      'shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button, .additional-checkout-buttons, [data-shopify-buttoncontainer], #paypal-button-container, .paypal-buttons'
    );
    hosts.forEach(function (host) {
      if (isPayPalNode(host)) toggleHidden(host, on);
      hideInRoot(host, on);
      if (host.shadowRoot) hideInRoot(host.shadowRoot, on);
    });
    // Light document-level PayPal leftovers (outside hosts)
    document
      .querySelectorAll(
        '.shopify-payment-button__button--paypal, #paypal-button-container, .paypal-buttons, [data-paypal-button], [data-holster-paypal-hidden="1"]'
      )
      .forEach(function (node) {
        toggleHidden(node, on);
      });
  }

  function syncNotes(on) {
    // Explanatory cart note removed; keep any leftover nodes hidden.
    document.querySelectorAll('[data-holster-paypal-note]').forEach(function (el) {
      el.hidden = true;
      el.setAttribute('hidden', '');
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function evaluateFromCart(cart) {
    var restricted = !!(cfg().productRestricted || cfg().restricted);
    if (cart && Array.isArray(cart.items)) {
      for (var i = 0; i < cart.items.length; i++) {
        if (itemRestricted(cart.items[i])) {
          restricted = true;
          break;
        }
      }
      // If Liquid said restricted but cart only has non-restricted types and
      // productRestricted is false, trust cart.js product_type (AJAX updates).
      if (!cfg().productRestricted && cart.items.length) {
        restricted = cart.items.some(itemRestricted);
      }
    }
    setRestricted(restricted);
  }

  // In-flight guard: refresh() fetches /cart.js; without this, a fetch patch
  // that also matches /cart.js schedules infinite nested refreshes and starves
  // cart UI updates (badge + drawer stuck after ATC).
  var refreshPending = false;
  var refreshQueued = false;

  function refresh() {
    if (refreshPending) {
      refreshQueued = true;
      return;
    }
    refreshPending = true;
    refreshQueued = false;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(evaluateFromCart)
      .catch(function () {
        setRestricted(!!(cfg().restricted || cfg().productRestricted));
      })
      .finally(function () {
        refreshPending = false;
        if (refreshQueued) {
          refreshQueued = false;
          window.setTimeout(refresh, 80);
        }
      });
  }

  function scheduleRefreshAfterMutation() {
    window.setTimeout(refresh, 50);
    window.setTimeout(refresh, 400);
  }

  function boot() {
    setRestricted(!!(cfg().restricted || cfg().productRestricted));
    refresh();

    document.addEventListener('cart:update', refresh);
    document.addEventListener('cart:refresh', refresh);
    document.addEventListener('cart:change', refresh);
    document.addEventListener('theme:cart:change', refresh);

    // Horizon / native cart events
    document.addEventListener('cart-drawer:refreshed', refresh);
    document.addEventListener('variant:change', function () {
      // PDP variant change does not change product type/tags; keep product flag
      setRestricted(!!(cfg().productRestricted || document.documentElement.classList.contains('holster-paypal-restricted')));
      refresh();
    });

    // Observe express button injection
    var mo = new MutationObserver(function () {
      if (document.documentElement.classList.contains('holster-paypal-restricted')) {
        hideButtons(true);
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // Patch fetch for /cart/* mutations ONLY — never /cart.js reads.
    // Matching /cart.js caused: refresh → fetch(/cart.js) → schedule refresh → ∞
    if (window.fetch && !window.fetch.__holsterPaypalRestrict) {
      var orig = window.fetch.bind(window);
      window.fetch = function () {
        var args = arguments;
        return orig.apply(window, args).then(function (res) {
          try {
            var url = String((args[0] && args[0].url) || args[0] || '');
            if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$|\/)/.test(url)) {
              scheduleRefreshAfterMutation();
            }
          } catch (e) {}
          return res;
        });
      };
      window.fetch.__holsterPaypalRestrict = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
